import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

/**
 * Description component renders a paragraph with optional custom className.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The content to display inside the paragraph.
 * @param {string} [props.className] - Optional additional class name(s).
 * @returns {JSX.Element}
 */
export const Description = ({ children, className }) => (
  <p className={cx(styles.description, { [String(className)]: className })}>
    {children}
  </p>
);
